import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as InvoiceAction from 'actions/invoice-action';
import * as OrderAction from 'actions/order-action';
import * as OTROrderAction from 'actions/otr/otr-order-action';
import { viewInvoiceReport } from 'services/invoice-service';
import { viewInvoiceReport as viewInvoiceReportOTR } from 'services/otr/otr-invoice-service';
import {
  Box,
  Button,
  Grid,
  Typography,
  IconButton,
  TextField,
  Chip,
  CircularProgress,
  useTheme,
  Tabs,
  Tab,
  Menu,
  MenuItem,
  Divider,
  Fade,
} from '@mui/material';
import Page from 'components/Page';
import PageHeader from 'global/PageHeader';
import Searchbar from 'global/Searchbar';
import Notificationbar from 'global/Notificationbar';
import InvoiceTable from './invoice-table';
import CustomSelectField from 'components/Select-Field/custom-select';
import { CancelOutlined, CheckCircleOutlineOutlined, CloseOutlined, InfoOutlined, MenuOutlined, WarningOutlined } from '@mui/icons-material';
import CTTabs from 'components/CTTabs';
import DataDialog from 'components/dialogs/DataDialog';
import OrderExpense from 'containers/expenses/order-expense';
import * as ExpenseService from 'services/expense-service';
import * as OTRExpenseService from 'services/otr/otr-expense-service';
import * as InvoiceService from 'services/invoice-service';
import * as OTRInvoiceService from 'services/otr/otr-invoice-service';
import Remittance from './remittance';
import FilesModal from 'components/files-modal';
import { AggregateOrderExpenses } from 'utils/calculations';
import { getRemittanceInformation } from 'services/remittance-service';
import { getFilesByOrderId } from 'services/order-service';
import NotificationDialog from 'components/dialogs/NotificationDialog';
import SelectInput from 'components/Select-Field/select-field';

import { DateRangePicker } from 'rsuite';
import ChartContainer from 'components/Charts/chart-container';
import { tokens } from 'theme/tokens';
import PieChart from 'components/Charts/piechart';
import { formatCurrency } from 'utils/formatter';
import BarChart from 'components/Charts/barchart';
import ContentDrawer from 'components/ContentDrawer';
import LoadDetail from 'containers/Dispatch/views/load-detail';
import FTIcons from 'assets/icons/FTIcons';

const INVOICE_STATUS_TABS = ['UNPAID', 'INVOICED', 'RECEIVED', 'RECEIVED_PARTIAL'];
const PIE_CHART_COLORS = {
  'RECEIVED': '#1F8E3D',
  'RECEIVED_PARTIAL': '#1F8E3D',
  'INVOICED': '#2684FF',
  'UNPAID': '#D92D20'
};
const SEARCH_FIELDS = [
  { 'name': 'broker', 'label': 'broker', 'type': 'datalist' },
  { 'name': 'orderId', 'label': 'Order Id', 'type': 'text' },
  { 'name': 'brokerReferenceNumber', 'label': 'Reference Number', 'type': 'text' },
  { 'name': 'containerNumber', 'label': 'Container Number', 'type': 'text' },
  { 'name': 'paymentNumber', 'label': 'Payment Number', 'type': 'text' },
];

const InvoiceManager = (props) => {

  /* Theme */
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const fileModalChildRef = useRef(null);
  const dispatch = useDispatch();
  const { tenantBusinessModel } = props.tenant;
  const mode = tenantBusinessModel === 'ALL' ? 'INTERMODAL' : tenantBusinessModel; // In case of ALL > we can default to Intermodal

  /* State Variables */
  const [tabIndex, setTabIndex] = useState(0);
  const [invoiceStatus, setInvoiceStatus] = useState('UNPAID');
  const [selectedRows, setSelectedRows] = useState([]); // Invoice Object
  const [transportationMode, setTransportationMode] = useState(mode);

  const [anchorMainMenu, setAnchorMainMenu] = useState(null);

  /* DIALOGS */
  const [isExpenseDialogOpen, setExpenseDialog] = useState(false);
  const [isOrderDetailDialogOpen, setOrderDetailDialog] = useState(false);
  const [isRemittancePaymentDialogOpen, setRemittancePaymentDialog] = useState(false);
  const [isProcessPayment, setProcessPayment] = useState(false);  //Process Payment will have both payment form and payment table.
  const [isNotificationDialogOpen, setNotificationDialog] = useState(false);
  const [isDocumentUploadDialogOpen, setDocumentUploadDialog] = useState(false);
  const [isAdvanceSearchDialogOpen, setAdvanceSearchDialog] = useState(false);

  const [isSearchEnabled, setSearchEnable] = useState(false);
  const [searchParameters, setSearchParameters] = useState({});

  const [expenses, setExpenses] = useState([]);
  const [expenseFormAction, setExpenseFormAction] = useState('Save');

  const [remittanceData, setRemittanceData] = useState([]);
  const [selectedInvoiceOrderId, setSelectedInvoiceOrderId] = useState(null);
  const [dateRange, setDateRange] = useState(null);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [invoiceCountsByStatus, setInvoiceCountsByStatus] = useState([]);

  const [isActionProcessed, setActionProcessed] = useState(false);

  const initState = {
    expense: {
      id: '',
      category: '',
      categoryDescription: '',
      name: '',
      billableAmount: '',
      companyShare: '',
      driverShare: '',
      isPerDay: false,
      expenseType: 'BILLABLE',
    },
    remittanceModel: {
      paymentAmount: '',
      paymentNumber: '',
      paymentDate: '',
      paymentMode: '',
      transactionType: 'INVOICE'
    },
    dialogMessage: {
      type: '',
      title: '',
      description: '',
    }
  };

  const INVOICE_DATE_MAP = { 'INVOICE CREATE DATE': 'invoiceDate', 'INVOICE GENERATE DATE': 'generationDate', 'PAYMENT DATE': 'paymentReceivedDate' };
  const [dateFilter, setDateFilter] = useState(null);

  const [expense, setExpense] = useState(initState.expense);
  const [remittanceModel, setRemittanceModal] = useState(initState.remittanceModel);
  const [dialogMessage, setDialogMessage] = useState(initState.dialogMessage);

  useEffect(() => {
    const isOTR = transportationMode === 'OTR';
    const invoiceService = isOTR ? OTRInvoiceService : InvoiceService;
    invoiceService.getInvoiceCounts().then(res => {
      setInvoiceCountsByStatus(res.data);
      setActionProcessed(false);
    });
    if (invoiceStatus && !isSearchEnabled) {
      loadInvoicesByStatus();
    } else {
      executeSearch();
    }
  }, [invoiceStatus, isSearchEnabled, isActionProcessed, transportationMode, page, pageSize]);

  const changeTab = (tabIndex) => {
    const status = INVOICE_STATUS_TABS[tabIndex];
    setTabIndex(tabIndex);
    setInvoiceStatus(status);
  };

  const handlePageSizeChange = (evt) => {
    setPageSize(parseInt(evt.target.value, 10));
    setPage(0);
  };
  /* Utils */
  const notify = (type, title, message) => {
    const notify = {
      type: type,
      title: title,
      description: message || 'No invoice selected. Please select at least one invoice to continue'
    };
    setDialogMessage(notify);
    setNotificationDialog(true);
  };

  const countByPaymentStatus = (countsByStatus) => {
    const result = Object.keys(countsByStatus).map(key => {
      const record = countsByStatus[key];
      return { status: key, count: record.totalRows };
    });
    return result;
  };

  /* SEARCH INVOICES */
  const handleSearchFieldChange = (evt, fieldName) => {
    const searchParams = searchParameters;
    const name = fieldName;
    let value = '';
    const param = {};
    if (fieldName === 'date-range') {
      if (evt && evt.length === 2) {
        const prefix = INVOICE_DATE_MAP[dateFilter];
        if (prefix) {
          const start = evt[0].toISOString().substring(0, 10);
          const end = evt[1].toISOString().substring(0, 10);
          setDateRange(evt);
          param[`${prefix}Start`] = start;
          param[`${prefix}End`] = end;
        } else {
          alert('Please select date filter type');
        }
      } else {
        setDateRange(evt);
      }
    } else {
      if (evt) {
        value = fieldName === 'broker' ? evt.value : evt.target.value;
        param[`${name}`] = value.trim();
      }
    }
    setSearchParameters(Object.assign(searchParams, param));
  };

  // Clear Search Fields - No auto search.
  const clearSearchField = (evt, fieldName) => {
    const params = searchParameters;
    if (params[fieldName]) {
      delete params[fieldName];
      // We need to clear this filtered searchOption from the searchParameters and input box.
      Array.from(document.querySelectorAll('input')).forEach(input => {
        if (input.name === fieldName) //true
          input.value = null;
      });
      setSearchParameters(params);
    }
  };

  /* Execute Search and also save state of the search variables */
  const executeSearch = () => {
    const isOTR = transportationMode === 'OTR';
    if (searchParameters && Object.entries(searchParameters).length > 0) {
      const params = {
        searchParam: Object.entries(searchParameters).map(([k, v]) => ({ 'label': k, 'value': v }))
      };
      setAdvanceSearchDialog(false);
      setSearchEnable(true);
      dispatch(InvoiceAction.search(invoiceStatus, params, isOTR, page, pageSize));
    } else {
      setAdvanceSearchDialog(false);
      setSearchParameters({});
      setSearchEnable(false);
    }
  };

  /* Create Search Chip */
  const createSearchChip = () => {
    const kvpair = Object.entries(searchParameters).map(([k, v]) => ({ 'key': k, 'value': v }));
    const chips = kvpair.map(item => (<Chip key={item.key}
      label={item.value}
      onDelete={(evt) => deleteSearchChip(evt, item.key)}
      color='secondary'
      size='small'
      style={{ marginRight: 5 }}
    />
    ));
    return chips;
  };

  const deleteSearchChip = (evt, key) => {
    clearSearchField(evt, key);
    // Execute search on remaining search items if any.
    executeSearch();
  };

  /* Loading Invoice By Status. Called at initial page load and every time user changes tab */
  const loadInvoicesByStatus = () => {
    const isOTR = transportationMode === 'OTR';
    const data = [];
    const params = {
      searchParam: data
    };
    dispatch(InvoiceAction.findInvoices(invoiceStatus, params, isOTR, page, pageSize));
  };

  const toggleMainMenu = (evt) => {
    const target = evt ? evt.currentTarget : null;
    setAnchorMainMenu(target);
  };
  /* INVOICE FUNCTIONS */
  const processViewReport = () => {
    if (selectedRows.length === 0) {
      notify('INFO', 'View Report');
    } else {
      const isOTR = transportationMode === 'OTR';
      const date = new Date(new Date().toDateString()).toISOString();
      const invoiceIds = selectedRows.map(inv => inv.id);
      isOTR ? viewInvoiceReportOTR(invoiceIds, date) : viewInvoiceReport(invoiceIds, date);
    }
  };

  const processGenerateInvoice = () => {
    if (selectedRows.length === 0) {
      notify('INFO', 'Generate Invoice');
    } else {
      const isOTR = transportationMode === 'OTR';
      const date = new Date(new Date().toDateString()).toISOString();
      const invoiceIds = selectedRows.map(inv => inv.id);
      dispatch(InvoiceAction.generateInvoice(invoiceIds, date, isOTR));
      isOTR ? viewInvoiceReportOTR(invoiceIds, date) : viewInvoiceReport(invoiceIds, date);
    }
  };

  const processRevertInvoice = () => {
    if (selectedRows.length === 0) {
      notify('INFO', 'Revert Invoice');
    } else {
      const isOTR = transportationMode === 'OTR';
      const invoiceIds = selectedRows.map(inv => inv.id);
      dispatch(InvoiceAction.unInvoice(invoiceIds, isOTR));
    }
  };

  /* PROCESS INVOICE PAYMENT */
  const processInvoice = () => {
    let isPaymentAmountInvalid = false;
    let isPaymentAmountNegative = false;
    if (selectedRows.length === 0) {
      notify('INFO', 'Process Invoice');
    } else {
      let totalAmount = 0;
      selectedRows.forEach(inv => {
        const balance = inv.invoiceTotal - inv.paymentReceived;
        if (inv.customAmount > balance) {
          isPaymentAmountInvalid = true;
        } else if (inv.customAmount < 0) {
          isPaymentAmountNegative = true;
        }
        if (isPaymentAmountInvalid || isPaymentAmountNegative) {
          const message = isPaymentAmountInvalid ? `Payment amount for invoice  ${inv.id} more than balance amount. Cannot process the payment.` : `Payment amount for invoice  ${inv.id} is negative. Cannot process the payment.`;
          notify('ERROR', 'View Report', message);
        } else {
          totalAmount += inv.customAmount;
        }
      });
      if (!isPaymentAmountInvalid && !isPaymentAmountNegative) { // Extra level of checking
        remittanceModel.paymentAmount = totalAmount;
        remittanceModel.paymentDate = new Date().toISOString().split('T')[0],
        remittanceModel.transactionType = 'INVOICE'
        setRemittanceModal(remittanceModel);
        setProcessPayment(true); //This is to display the remittance form.
        setRemittancePaymentDialog(true);
      }
    }
  };

  const submitPayment = (remittanceModel) => {
    const invoices = []; //invoices to process
    selectedRows.forEach(inv => {
      const invoiceItem = {
        'invoiceId': inv.id,
        'orderId': inv.orderId,
        'invoiceAmount': inv.customAmount
      };
      invoices.push(invoiceItem);
    });

    const paymentData = {
      remittanceModel,
      invoices
    };
    dispatch(InvoiceAction.processPayment(paymentData, transportationMode == 'OTR'));
  };

  /* Factoring Services */
  const viewFactoringInvoice = () => {
    const isOTR = transportationMode === 'OTR';
    const invoiceService = isOTR ? OTRInvoiceService : InvoiceService;
    if (selectedRows.length === 0) {
      notify('INFO', 'Factoring Invoice');
    } else {
      const invoiceIdList = selectedRows.map(inv => inv.id);
      const url = invoiceService.viewFactoringInvoice(invoiceIdList);
      window.open(url + '?accesstoken=' + localStorage.AUTH_TOKEN);
    }
  };

  const printFactoringInvoice = () => {
    const isOTR = transportationMode === 'OTR';
    const invoiceService = isOTR ? OTRInvoiceService : InvoiceService;
    if (selectedRows.length === 0) {
      notify('INFO', 'Factoring Invoice');
    } else {
      const invoiceIdList = selectedRows.map(inv => inv.id);
      invoiceService.printFactoringInvoice(invoiceIdList);
    }
  };

  const processOrderDetail = (orderId) => {
    const isOTR = transportationMode === 'OTR';
    if (isOrderDetailDialogOpen) {      
      if (isOTR) {
        dispatch(OTROrderAction.resetState('RESET_ORDER_STATE'));
      } else {
        dispatch(OrderAction.resetState('RESET_ORDER_STATE'));
      }
      setOrderDetailDialog(false);
    } else {
      if (isOTR) {
        dispatch(OTROrderAction.getOTROrderById(orderId));
      } else {
        dispatch(OrderAction.getOrderById(orderId));
      }
      setOrderDetailDialog(true);
    }
  };
  /* Menu Option Dialogs */
  /* Order Expense */
  const toggleExpenseDialog = (invoice) => {
    if (isExpenseDialogOpen) {
      loadInvoicesByStatus();
      setExpenseDialog(false);
      setSelectedInvoiceOrderId(null);
    } else {
      const { orderId } = invoice;
      // Select the appropriate service based on OTR status
      const expenseService = transportationMode === 'OTR' ? OTRExpenseService : ExpenseService;
      // Fetch expenses and update state
      expenseService.getExpensesByOrder(orderId)
        .then(res => {
          setExpenses(res.data);
          setSelectedInvoiceOrderId(orderId);
          setExpenseDialog(true);
        });
    }
  };

  const saveOrderExpense = (expense) => {
    // Select the appropriate service based on OTR status
    const expenseService = transportationMode === 'OTR' ? OTRExpenseService : ExpenseService;
    expenseService.saveOrderExpense(selectedInvoiceOrderId, expense).then(res => {
      loadInvoicesByStatus();
    });
  };

  const editOrderExpense = (expense) => {
    setExpense(expense);
    setExpenseFormAction('Update');
  };

  const updateOrderExpense = (expense) => {
    // Select the appropriate service based on OTR status
    const expenseService = transportationMode === 'OTR' ? OTRExpenseService : ExpenseService;
    expenseService.updateOrderExpense(selectedInvoiceOrderId, expense).then(res => {
      loadInvoicesByStatus();
    });
  };

  const deleteOrderExpense = (expense) => {
    // Select the appropriate service based on OTR status
    const expenseService = transportationMode === 'OTR' ? OTRExpenseService : ExpenseService;
    expenseService.deleteOrderExpense(expense.id, selectedInvoiceOrderId).then(() => {
      loadInvoicesByStatus();
    });
  };

  const processViewRemittance = (invoice) => {
    if (isRemittancePaymentDialogOpen) {
      setRemittancePaymentDialog(false);
      setProcessPayment(false);
    } else {
      const isOTR = transportationMode === 'OTR';
      getRemittanceInformation('invoice', invoice.id, isOTR).then(res => { //isOTR = false
        setRemittanceData(res.data);
        setProcessPayment(false); // We are not processing any remittance here. Only view mode.
        setRemittancePaymentDialog(true);
      });
    }
  };

  const processDocumentUpload = (invoice) => {
    if (isDocumentUploadDialogOpen) {
      setDocumentUploadDialog(false);
    } else {
      const isOTR = transportationMode === 'OTR';
      const { orderId } = invoice;
      setSelectedInvoiceOrderId(orderId);
      // const documentUploadService = transportationMode === 'OTR' ?  : ExpenseService;
      getFilesByOrderId(orderId, isOTR)
        .then((res) => {
          if (res.status === 200 && res.data) {
            // res.data
            fileModalChildRef.current.onInit(res.data);
          }
        })
        .catch((e) => {
          // pass error
          fileModalChildRef.current.onInit(null, e);
        });
      setDocumentUploadDialog(true);
    }
  };

  const toggleAdvanceSearchDialog = () => {
    setAdvanceSearchDialog(!isAdvanceSearchDialogOpen);
  };

  const getBrokerLabel = (broker) => {
    const primaryText = broker.name;
    const secondaryText = broker.address && `${broker.address.street},${broker.address.city},${broker.address.state},${broker.address.country}`;
    const reactSelectObj = {
      label: <Box>
        <Typography variant='body1' fontWeight={600}>{primaryText}</Typography>
        <Typography variant='caption'>{secondaryText}</Typography>
      </Box>,
      value: primaryText
    };
    return reactSelectObj;
  };

  const closeActionResultDialog = () => {
    dispatch(InvoiceAction.resetState('RESET_TOAST_STATE'));
    setActionProcessed(true);
  };

  /* Chart Function */
  const invoiceBreakdownPieChart = (countsByStatus) => {
    const result = Object.keys(countsByStatus).map(key => {
      const record = countsByStatus[key];
      return { id: key, label: key, count: record.totalRows, value: Number(record.invoiceTotal) };
    });
    return result;
  };

  const getTopBrokers = (invoices) => {
    const result = Object.values(
      invoices.reduce((acc, { brokerName, invoiceTotal }) => {
        if (!acc[brokerName]) {
          acc[brokerName] = { brokerName, total: 0 };
        }
        acc[brokerName].total += invoiceTotal;
        return acc;
      }, {})
    );
    const top5Brokers = result
      .sort((a, b) => b.total - a.total) // desc
      .slice(0, 5)
      .map(({ brokerName, total }) => ({
        'Broker': brokerName,
        'Total': Number(total)
      }));
    return top5Brokers.sort((a, b) => a.Total - b.Total); //desc;
  };

  const { invoices, searched, totalCounts, brokers, activeOrder, toast, isProcessing } = props;

  const invoiceData = isSearchEnabled && searched ? searched : invoices || [];
  /* totalCounts vs invoiceCountsByStatus */
  /* When we are searching we need to use totalCounts because it is related to specific search parameters */
  const tabStatusCount = isSearchEnabled ? countByPaymentStatus(totalCounts) : countByPaymentStatus(invoiceCountsByStatus);
  const totalRowCount = isSearchEnabled ? totalCounts[invoiceStatus] : totalCounts;
  const totalSearchCount = isSearchEnabled && totalCounts ? Object.values(totalCounts).reduce((acc, item) => { return (acc + item.totalRows); }, 0) : 0;

  const filteredData = isSearchEnabled ? invoiceData.filter(inv => inv.paymentStatus === INVOICE_STATUS_TABS[tabIndex]) : invoiceData;

  const invoiceBreakdownData = isSearchEnabled ? invoiceBreakdownPieChart(totalCounts) : invoiceBreakdownPieChart(invoiceCountsByStatus);
  const topBrokers = getTopBrokers(invoiceData);

  let content = null;
  if (toast && toast.action && toast.message) {
    content = toast.message.map((msg, idx) =>
      <React.Fragment key={idx}>
        <Typography variant='h6'>{msg.includes('SUCCESS') ?
          <CheckCircleOutlineOutlined style={{ color: 'green', marginBottom: '-8px' }} /> :
          <CancelOutlined style={{ color: 'red', marginBottom: '-8px' }} />}&nbsp;&nbsp;{msg}
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  return (
    <Page title='Invoice'>
      <Box display={'flex'} justifyContent={'space-between'}>
        <PageHeader
          title='Invoice Management'
          subTitle='Manage your customer invoices.'
        />
        <Searchbar
          searchType='ADVANCED'
          isAdvanceSearchDialogOpen={isAdvanceSearchDialogOpen}
          searchParameters={searchParameters}
          fnSearchMenuHandler={toggleAdvanceSearchDialog}
        >
          <Grid container spacing={1}>
            {SEARCH_FIELDS.map(field => {
              return (
                field.type === 'datalist' ?
                  <Grid size={{ xs: 12, sm: 8 }} key={field.name}>
                    <CustomSelectField
                      type='BROKER'
                      id='brokers'
                      label='Broker Name'
                      name={field.name}
                      data={brokers.map(b => getBrokerLabel(b))}
                      onChange={selected => handleSearchFieldChange(selected, field.name)}
                    />
                  </Grid> :
                  <Grid size={{ xs: 6, sm: 4 }} key={field.name}>
                    <TextField
                      key={field.name}
                      label={field.label}
                      margin='dense'
                      variant='outlined'
                      name={field.name}
                      type={field.type}
                      fullWidth={true}
                      size='small'
                      onChange={evt => handleSearchFieldChange(evt, field.name)}
                      InputProps={{
                        endAdornment: (<IconButton size='small' name={field.name} onClick={(evt) => clearSearchField(evt, field.name)}>
                          <CloseOutlined fontSize='small' />
                        </IconButton>
                        )
                      }}
                    />
                  </Grid>
              );
            })}
          </Grid>
          <Grid container spacing={1}>
            <Grid size={{ xs: 6, sm: 6 }}>
              <SelectInput
                label='Select Date Type'
                name='dateFilter'
                value={dateFilter}
                variant='outlined'
                fullWidth
                onChange={evt => setDateFilter(evt.target.value)}
                options={Object.keys(INVOICE_DATE_MAP)}
              />
            </Grid>
            <Grid size={{ xs: 6, sm: 6 }}>
              <DateRangePicker
                placeholder='Enter Date Range'
                name='date-range'
                format='MMM dd, yyyy'
                value={dateRange}
                showWeekNumbers
                onChange={evt => handleSearchFieldChange(evt, 'date-range')}
              />
            </Grid>
          </Grid>
          <Box
            display='flex'
            justifyContent='flex-end'
            p={2}
          >
            <Button
              variant='contained'
              color='primary'
              onClick={() => executeSearch()}
            >
              Search
            </Button>
          </Box>
        </Searchbar>
        <Notificationbar />
      </Box>
      <Box
        m='20px 0 0 0'
        height='75vh'
      >
        {isSearchEnabled &&
          <Box style={{ margin: '10px 0' }} textAlign={'center'}>
            <Box flex={1}>
              {createSearchChip()}
            </Box>
            <Typography variant='caption'
              style={{
                letterSpacing: 1,
                color: colors.neutral[500],
                textTransform: 'uppercase',
                marginTop: 0.5,
                fontWeight: 500,
              }}
            >
              {`${totalSearchCount} records found`}
            </Typography>
          </Box>
        }
        <Box
          display={'flex'}
          mb={1}
        >
          {tenantBusinessModel === 'ALL' &&
            <Tabs
              value={transportationMode}
              onChange={(evt, value) => setTransportationMode(value)}
              textColor={colors.base.white}
              indicatorColor='primary'
              sx={{
                background: colors.neutral[100],
                borderRadius: '4px',
                padding: '4px',
                height: 6,
                gap: '4px',

              }}
            >
              {['INTERMODAL', 'OTR'].map((mode, idx) => (
                <Tab
                  key={`${idx}-${mode}`}
                  value={mode}
                  label={mode === 'INTERMODAL' ? 'Intermodal' : 'OTR'}
                  sx={{
                    minHeight: '40px',
                    padding: '6px 16px',
                    borderRadius: '4px',
                    fontWeight: 500,
                    backgroundColor:
                      transportationMode === mode ? colors.base.white : 'transparent',
                    borderBottom: '1px solid',
                    borderBottomColor:
                      transportationMode === mode ? colors.base.white : 'transparent',
                    '&:hover': {
                      backgroundColor:
                        transportationMode === mode
                          ? colors.primary.dark
                          : colors.neutral[200],
                    },
                  }}
                />
              ))
              };
            </Tabs>
          }
        </Box>
        {isProcessing && <CircularProgress style={{ position: 'absolute', top: '50%', marginLeft: '50%' }} />}
        <Grid container spacing={1}>
          <Grid size={{ xs: 12, sm: 9, md: 9 }}>
            <Box
              sx={{
                display: 'flex',
                borderRadius: '6px 6px 0px 0px',
                py: 1,
                px: 1,
                justifyContent: 'space-between',
                background: colors.blue[50]
              }}
            >
              <CTTabs
                labels={INVOICE_STATUS_TABS}
                tabIndex={tabIndex}
                counts={tabStatusCount}
                exportButtonEnabled={true}
                fnOnTabChangeHandler={(tabIndex) => changeTab(tabIndex)}
              />
              {selectedRows.length > 0 &&
                <Fade in={selectedRows.length > 0} timeout={300} unmountOnExit>
                  <Box display={'flex'} justifyContent={'space-between'}>
                    <Typography variant='body1' sx={{
                      margin: 'auto 5px',
                      background: colors.neutral[400],
                      padding: .5,
                      color: colors.base.white,
                      borderRadius: 1
                    }}
                    >
                      {selectedRows.length} Selected
                    </Typography>
                    <Typography variant='body1' sx={{
                      margin: 'auto 5px',
                      background: colors.neutral[400],
                      padding: .5,
                      color: colors.base.white,
                      borderRadius: 1
                    }}
                    >
                      {formatCurrency(selectedRows.reduce((acc, item) => { return (acc + item.invoiceTotal); }, 0))}
                    </Typography>                    
                    <IconButton
                      aria-label='settings'
                      onClick={evt => toggleMainMenu(evt)}
                      size='small'
                      sx={{
                        margin: 'auto',
                        bgcolor: colors.primary.light,
                        color: colors.base.white,
                        '&:hover': {
                          bgcolor: colors.primary.main,
                        }
                      }}
                    >
                      <MenuOutlined
                        color={colors.primary.light}
                      />
                    </IconButton>
                  </Box>
                </Fade>
              }
              <Menu
                id='long-menu'
                anchorEl={anchorMainMenu}
                open={Boolean(anchorMainMenu)}
                keepMounted
                onClose={() => toggleMainMenu(null)}
              >
                <Typography variant='body2'
                  sx={{ bgcolor: colors.neutral[300], fontWeight: 500, padding: 1, textAlign: 'center' }}>
                  General
                </Typography>
                <MenuItem onClick={() => processViewReport()}>
                  <FTIcons.PreviewIcon fill={colors.primary.light} /> &nbsp;&nbsp;Preview
                </MenuItem>
                <Divider />
                <MenuItem disabled={tabIndex !== 0} onClick={() => processGenerateInvoice()}>
                  <FTIcons.CogIcon fill={colors.primary.light} />&nbsp;&nbsp;Generate Invoice
                </MenuItem>
                <Divider />
                <MenuItem disabled={tabIndex !== 1 || tabIndex === 3} onClick={() => processInvoice()}>
                  <FTIcons.LightningIcon fill={colors.primary.light} />&nbsp;&nbsp;Receive Invoice
                </MenuItem>
                <Divider />
                <MenuItem disabled={tabIndex === 0} onClick={() => processRevertInvoice()}>
                  <FTIcons.CogIcon fill={colors.primary.light} />&nbsp;&nbsp;Revert
                </MenuItem>
                <Typography variant='body2'
                  sx={{ bgcolor: colors.neutral[300], fontWeight: 500, padding: 1, textAlign: 'center' }}>
                  Factoring
                </Typography>
                <MenuItem onClick={() => viewFactoringInvoice()}>
                  <FTIcons.PreviewIcon fill={colors.primary.light} /> &nbsp;&nbsp;Preview
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => printFactoringInvoice()}>
                  <FTIcons.PrinterIcon fill={colors.primary.light} /> &nbsp;&nbsp;Print
                </MenuItem>
              </Menu>
            </Box>
            <InvoiceTable
              isOTR={transportationMode === 'OTR'}
              invoices={filteredData || []}
              page={page}
              pageSize={pageSize}
              rowCount={totalRowCount && totalRowCount.totalRows}
              fnViewOrderHandler={(orderId) => processOrderDetail(orderId)}
              fnExpenseHandler={toggleExpenseDialog}
              fnViewRemittanceHandler={processViewRemittance}
              fnDocumentUploadHandler={processDocumentUpload}
              fnOnHandleTabChange={(tabName) => changeTab(tabName)}
              fnOnRowSelection={(rows) => setSelectedRows(rows)}
              fnOnPageChange={(evt, newPage) => setPage(newPage)}
              fnOnPageSizeChange={handlePageSizeChange}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3, md: 3 }}>
            <Grid container spacing={1}>
              <Grid size={{ xs: 12 }}>
                <ChartContainer
                  title='Invoice Breakdown'
                  height='360px'
                  width='370px'
                >
                  <Box sx={{ width: 'auto', height: 200 }}>
                    <PieChart
                      data={invoiceBreakdownData || []}
                      customColor={true}
                    />
                  </Box>
                  {invoiceBreakdownData && invoiceBreakdownData.map(item => (
                    <Grid container spacing={1} key={item.label}>
                      <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                        <Typography variant='body1' sx={{ marginLeft: 1 }}>
                          <span style={{
                            border: `3px solid ${PIE_CHART_COLORS[item.label]}`,
                            height: '12px',
                            display: 'inline-block',
                            margin: '0px 5px',
                          }}></span>
                          {item.label}
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 3, sm: 3, md: 3 }}>
                        <Typography variant='body1'>{item.count}</Typography>
                      </Grid>
                      <Grid size={{ xs: 3, sm: 3, md: 3 }}>
                        <Typography variant='body1'>{formatCurrency(item.value, 'en-US', 'compact')}</Typography>
                      </Grid>
                    </Grid>
                  ))}
                </ChartContainer>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <ChartContainer
                  title='Top 5 Brokers'
                  height='360px'
                  width='370px'
                >
                  <Box sx={{ height: 250 }}>
                    <BarChart
                      data={topBrokers || []}
                      keys={['Total']}
                      indexKey={'Broker'}
                      groupMode={'stacked'}
                      layout={'horizontal'}
                      margin={{top: 30, right: 80, bottom: 0, left: 160}}
                      valueFormat={true}
                      valueScale={{type: 'symlog'}}
                    />
                  </Box>
                </ChartContainer>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {/* ORDER DETAIL DIALOG */}
      {activeOrder && activeOrder.legs &&
        <ContentDrawer
          open={isOrderDetailDialogOpen}
          title='Load Detail'
          handleClose={() => processOrderDetail()}
        >
          {transportationMode === 'OTR' ?
            <LoadDetail
              order={activeOrder}
              transportationMode='OTR'
            /> :
            <LoadDetail
              order={activeOrder}
              transportationMode='INTERMODAL'
            />
          }
        </ContentDrawer>
      }
      {/* ORDER EXPENSE */}
      <DataDialog
        open={isExpenseDialogOpen}
        title={'Expense'}
        width={'md'}
        isProcessing={isProcessing}
        toast={toast}
        onCloseHandler={() => setExpenseDialog(false)}
      >
        <OrderExpense
          action={expenseFormAction}
          expense={expense}
          expenseList={expenses}
          fnOnSaveHandler={saveOrderExpense}
          fnOnEditHandler={editOrderExpense}
          fnOnUpdateHandler={updateOrderExpense}
          fnOnDeleteHandler={deleteOrderExpense}
        />
      </DataDialog>

      {/* VIEW PAYMENT */}
      <ContentDrawer
        open={isRemittancePaymentDialogOpen}
        title={'Receive Payment'}
        isProcessing={isProcessing}
        toast={toast}
        handleClose={() => setRemittancePaymentDialog(false)}
      >
        <Remittance
          remittanceModel={remittanceModel}
          remittanceData={remittanceData}
          isProcessPayment={isProcessPayment}
          fnOnSubmitPaymentHandler={submitPayment}
        />
      </ContentDrawer>

      {/* FILE UPLOAD */}
      <DataDialog
        open={isDocumentUploadDialogOpen}
        title={'Upload Documents'}
        width={'md'}
        onCloseHandler={() => setDocumentUploadDialog(false)}
      >
        <FilesModal
          ref={fileModalChildRef}
          errorData={''}
          messageData={''}
          filesData={[]}
          isOTR={transportationMode === 'OTR'}
          orderId={selectedInvoiceOrderId}
        />
      </DataDialog>
      {/* NOTIFICATION DIALOG */}
      <NotificationDialog
        open={isNotificationDialogOpen}
        title={<Box display={'flex'} alignItems={'center'}>
          {dialogMessage && dialogMessage.type === 'INFO' ? <InfoOutlined color='primary' /> : <WarningOutlined color='error' />}
          <Typography variant='h5' style={{ marginLeft: 8 }}>{dialogMessage.title} </Typography>
        </Box>}
        handleClose={() => setNotificationDialog(false)}
      >
        <Typography variant='subtitle2'>
          {dialogMessage.description}
        </Typography>
      </NotificationDialog>

      {/* ACTION UPDATES */}
      <DataDialog
        open={content !== null}
        title='Process Invoice'
        width={'sm'}
        onCloseHandler={() => closeActionResultDialog(false)}
      >
        {content}
      </DataDialog>
    </Page>
  );
};

function mapStatesToProps(state) {
  const { brokers } = state.brokerReducer;
  const { tenant } = state.tenantReducer;
  let activeOrder;
  let { invoices, invoice, searched, totalCounts, toast, isProcessing } = state.invoiceReducer;

  if (tenant && tenant.tenantBusinessModel) {
    if(tenant.tenantBusinessModel === 'INTERMODAL') {
      const order = state.orderReducer.order;
      if (order && order.id) {
          const fsc = order.fuelChargesType === '$' ? order.fuelCharges : .01 * order.fuelCharges * order.orderRate;
          const orderTotal = order.orderRate + fsc + AggregateOrderExpenses(order.expenses);
          invoices = invoices.map(inv => inv.orderId === order.id ? { ...inv, expenses: order.expenses, invoiceTotal: orderTotal } : { ...inv });
          activeOrder = order;
        }
    } else if (tenant.tenantBusinessModel === 'OTR') {
      const otrOrder = state.otrOrderReducer.order;
      if (otrOrder && otrOrder.id) {
        const fsc = otrOrder.fuelChargesType === '$' ? otrOrder.fuelCharges : .01 * otrOrder.fuelCharges * otrOrder.lineHaulCharges;
        const orderTotal = otrOrder.lineHaulCharges + fsc + AggregateOrderExpenses(otrOrder.expenses);
        invoices = invoices.map(inv => inv.orderId === otrOrder.id ? { ...inv, expenses: otrOrder.expenses, invoiceTotal: orderTotal } : { ...inv });
        activeOrder = otrOrder;
      }
    }
  } 
  return {
    activeOrder,
    brokers,
    tenant,
    invoice,
    invoices,
    totalCounts,
    searched,
    toast,
    isProcessing,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, OrderAction, OTROrderAction, InvoiceAction), dispatch);
}

// Promote InvoicePage from a component to a container - it needs to know
// about this new dispatch method, selectInvoice
export default connect(mapStatesToProps, mapDispatchToProps)(InvoiceManager);